import React from "react"

import type { MetricRecordData } from "@/types/metrics/contracts"
import type { RunMetricOutput } from "@/types/RunMetricOutput"

import { appendAgentJudgeEvidence } from "../agent-judge/agentJudgeEvidence"
import {
  AgentJudgeMetadataEditor,
  AgentJudgeNumericalConfiguration,
  AgentJudgeReadOnlyMetadata,
} from "../agent-judge/AgentJudgeMetadataEditor"
import { NumericalLLMMetricRecord } from "./NumericalLLMMetricRecord"

export class AgentJudgeNumericalMetricRecord extends NumericalLLMMetricRecord {
  renderReadOnlyMetadata(metricRecordData: MetricRecordData): React.ReactNode {
    const metadata = metricRecordData.metric_metadata ?? {}

    return (
      <AgentJudgeReadOnlyMetadata
        metricRecordData={metricRecordData}
        outputConfiguration={
          <div className="grid grid-cols-2 gap-4">
            <div>
              <p className="text-sm font-medium text-coval-text">Min Value</p>
              <p className="text-sm text-coval-text">{metadata.min_value}</p>
            </div>
            <div>
              <p className="text-sm font-medium text-coval-text">Max Value</p>
              <p className="text-sm text-coval-text">{metadata.max_value}</p>
            </div>
          </div>
        }
      >
        {super.renderReadOnlyMetadata(metricRecordData)}
      </AgentJudgeReadOnlyMetadata>
    )
  }

  renderEditorMetadata(
    metricRecordData: MetricRecordData,
    onChange: (metric: MetricRecordData) => void,
  ): React.ReactNode {
    return (
      <AgentJudgeMetadataEditor
        metricRecordData={metricRecordData}
        onChange={onChange}
        questionPlaceholder={
          "Enter a question that rates the conversation on your numerical scale.\n\nThe Agent Judge investigates only through the enabled read-only tools and returns a score within the configured range."
        }
        outputConfiguration={
          <AgentJudgeNumericalConfiguration
            metricRecordData={metricRecordData}
            onChange={onChange}
          />
        }
      />
    )
  }

  getDeepDiveSections(
    metricOutput: RunMetricOutput,
  ): { label: string; content: React.ReactNode }[] | null {
    return appendAgentJudgeEvidence(
      super.getDeepDiveSections(metricOutput),
      metricOutput,
    )
  }
}
